import { useContext } from "react";
import { SocketContext } from "../context/SocketContext";

// Custom hook to access the socket instance
export const useSockets = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error("useSocket must be used within a SocketProvider");
  }
  return context.socket;
};
